/* eslint max-lines: ["error", { "max": 700 }] */
/* eslint perfectionist/sort-objects: "error" */

export const FINCH_ERRORS = {
  CONNECT_CALLBACK_MISSING_EMPLOYER_INFORMATION:
    'Employer information is not available',
  CONNECT_CALLBACK_NO_CODE: 'Code is required to perform connection',
  CONNECT_PROCESS_FAILURE:
    'Connection process failed. Please try again or contact Zorro support if the problem persists.',
  ELIGIBILITY_CRITERIA_NOT_SET_OR_NOT_VALID:
    'Eligibility criteria is not set or not valid',
  INTEGRATION_MISSING_PROVIDER_ID: 'Integration is missing provider id',
  INTEGRATION_NO_ACCESS_TOKEN: 'Integration does not have access token',
  INTEGRATION_NO_ACTIVE: 'Integration is not active',
  INTEGRATION_NOT_FOUND: 'Integration not found',
  NO_ENABLED_EMPLOYER_ENTITIES: (finchEmployerId: string) =>
    `No enabled Finch employer entities found
Finch Employer ID: ${finchEmployerId}`,
  NO_PAY_GROUPS_ERROR: (
    finchEmployerId: string,
    employerName: string,
    providerId: string
  ) => `Pay Groups data returned empty
Employer: ${employerName}
Provider ID: ${providerId}
Finch Employer ID: ${finchEmployerId}`,
  PAY_GROUPS_RETURNED_501_ERROR: (
    finchEmployerId: string,
    employerName: string
  ) => `Error: getAllPayGroups returned 501 error
This employer may need to turn on shouldEstimatePayGroups if pay groups are not supported.
Employer: ${employerName}
Finch Employer ID: ${finchEmployerId}`,
  PROVIDER_NOT_FOUND: 'Provider does not exist',
  TOO_MANY_PAY_GROUPS_ERROR: (
    finchEmployerId: string,
    employerName: string,
    providerId: string
  ) => `Too many Pay Groups found
Employer: ${employerName}
Provider ID: ${providerId}
Finch Employer ID: ${finchEmployerId}`,
};

export const BENEFIT_ERRORS = {
  CARRIER_APPLICATION_NOT_SENT:
    'Carrier application must be sent before confirming enrollment',
  EFFECTIVE_FROM_AFTER_EFFECTIVE_UNTIL:
    'The effective start date cannot be later than the end date',
  EFFECTIVE_FROM_DATE_MISMATCH:
    'Effective from date must coincide with employee eligibility from date',
  EFFECTIVE_PERIOD_AFTER_ELIGIBILITY:
    "Effective period can't start after the end of eligibility (dismissed employee)",
  EFFECTIVE_PERIOD_NOT_WITHIN_COVERAGE_PERIOD:
    "The effective period must fall within the plan year's coverage period",
  EFFECTIVE_UNTIL_DATE_MISMATCH:
    'Effective until date must coincide with employee eligibility until date',
  EXCEED_BOUNDS_OPEN_ENROLLMENT:
    'Unable to exceed bounds of open enrollment period effective dates',
  NO_EFFECTIVE_DATES_SPECIFIED: 'No effective dates were specified',
  NOT_EXIST: 'Benefit does not exist',
};

export const ERROR_MESSAGES = {
  ADD_BENEFIT_TO_SUBMITTED_CART_ERROR_MESSAGE:
    'Cannot add to cart while a benefit on this onboarding period is already submitted. Please reset the election first.',

  ADDRESS_IS_PO_BOX_ERROR_MESSAGE:
    'Residential address cannot be a PO Box. Please enter a valid street address.',

  ADDRESS_NOT_SUPPORTED_ERROR_MESSAGE:
    'The provided address is not currently supported',

  ALLOWANCE_MODEL_IN_USE_ERROR_MESSAGE:
    'Quote saved. The allowance model is already in use and cannot be applied.',

  BENEFIT_DOCUMENT_NOT_FOUND_ERROR_MESSAGE: 'Benefit document not found',

  BENEFIT_NOT_SUBMITTED_ERROR_MESSAGE:
    'Benefit has not been submitted yet and cannot be processed',

  BENEFITS_NOT_FOUND_ERROR_MESSAGE: 'Benefits not found',

  CANNOT_DELETE_INSURED_EMPLOYEE: 'The employee cannot be deleted',

  CANNOT_DELETE_MAJOR_MEDICAL_BENEFIT_ERROR_MESSAGE:
    'Cannot delete a major medical benefit, please reset the election',

  CARRIER_NAME_NOT_FOUND_ERROR_MESSAGE: 'Carrier name not found',

  CONFLICTING_ENROLLMENTS_ERROR:
    'The employee already has an open enrollment for this year',

  COULD_NOT_CREATE_ACTIVATION_LINK_ERROR_MESSAGE:
    'Could not create activation link',

  COULD_NOT_EXTRACT_SUBMITTING_USER_DETAILS_ERROR_MESSAGE:
    'Could not extract details of submitting user for non-automatic submission',

  COULD_NOT_SEND_INVITATION_EMAIL_ERROR_MESSAGE:
    'Could not send invitation email',

  CouldNotCalculatePremiumContributions:
    'Could not calculate premium contributions',

  CouldNotCalculateWaiverEffectiveDates:
    'Could not calculate waiver effective dates',

  COVERAGE_SCOPE_LOCKED_ERROR_MESSAGE:
    'Coverage scope cannot be changed if at least one employee submitted their election',

  COVERAGE_START_AFTER_WINDOW_ERROR:
    'The start date of coverage must be after the election window ends',

  COVERAGE_START_EXCEEDS_COVERAGE_END_ERROR_MESSAGE:
    'The coverage start date is after the plan year or eligibility ends',

  DEPENDANT_OVERAGE_ERROR:
    'Dependent must be under 26 years old on the coverage effective date',

  DOMESTIC_PARTNER_NOT_ALLOWED:
    'Domestic partners are not allowed in this plan year',

  EDIT_SUBMITTED_PLAN_INVALID_STATUS_ERROR_MESSAGE:
    'This plan is not in an editable status',

  EFFECTIVE_DATE_REQUIRED_ERROR_MESSAGE: 'Effective date required',

  EFFECTIVE_DATES_OVERLAP: 'Effective dates overlap with a later enrollment',

  EFFECTIVE_OPEN_ENROLLMENT_PERIOD_NOT_FOUND_ERROR_MESSAGE:
    "Couldn't find an effective open enrollment period",

  ELECTION_END_DATE_FOR_QLE_ERROR_MESSAGE:
    'The election end date is too late for this plan year or eligibility period',

  ELECTION_WINDOW_CHANGE_AFTER_SUBMISSION_ERROR:
    "Can't change election window and expected start of coverage after election submission. Please reset election first",

  ELIGIBILITY_END_EARLIER_THAN_COVERAGE_ERROR:
    "The employee's eligibility ends before the expected start of coverage",

  ELIGIBILITY_START_DATE_MSG:
    'Eligibility start date must be the 1st of a month',

  ELIGIBILITY_START_LATER_THAN_COVERAGE_ERROR:
    "The employee's eligibility start date is later than the open enrollment coverage start date",

  ELIGIBILITY_STARTS_AFTER_START_OF_EXPECTED_COVERAGE_ERROR:
    'The expected start of coverage is before the employee becomes eligible for benefits',

  EMPLOYEE_REMOVED_FROM_PRIMARY_MEDICAL_ERROR_MESSAGE:
    'The employee cannot be removed from the primary medical plan. To change plans, reset the election',

  EMPLOYER_WITH_THE_SAME_TAX_ID_ALREADY_EXISTS_ERROR_MESSAGE:
    'Employer with the same taxId already exists',

  ENROLLMENT_ALREADY_EXISTS_ERROR:
    'The employee already has another enrollment with the same coverage start date',

  ENROLLMENT_COMMENT_NOT_FOUND_ERROR_MESSAGE: 'Enrollment comment not found',

  ENROLLMENT_ERRORS_MESSAGES: {
    EFFECTIVE_PERIOD_END_BEFORE_START:
      'The effective period must end after it begins',
    ONBOARDING_PERIOD_END_BEFORE_START:
      'The onboarding period must end after it begins',
  },

  ENROLLMENT_TEAM_AGENT_MISMATCH_ERROR_MESSAGE:
    'The enrollment agent should belong to the enrollment team',

  ENROLLMENT_TEAM_MISSING_ERROR_MESSAGE:
    'An enrollment team must be selected when assigning an enrollment agent',

  EXISTING_SUBMITTED_BENEFIT_ERROR_MESSAGE:
    'Open enrollment periods cannot have existing submitted or enrolled benefits connected to it',

  EXPECTED_COVERAGE_START_DATE_FOR_QLE_ERROR_MESSAGE:
    'The expected coverage start date for this qualifying life event is after the plan year or eligibility ends',

  FAILED_GETTING_SPECIALTIES_ERROR_MESSAGE:
    'Failed to get specialties from ideon',

  FAMILY_UNIT_NOT_ALLOWED_ERROR_MESSAGE: 'Family unit update not allowed',

  FINALIZED_PERIOD_OVERLAP_ERROR_MESSAGE:
    'The new coverage window overlaps an existing one which was already sent to the carrier',

  GENERATE_PDF_FAILED_ERROR_MESSAGE: 'Failed to generate PDF',

  getActiveOnboardingPeriodAlreadyExistsErrorMessage: (employeeId: string) => {
    return `There is already an active onboarding period for employee ${employeeId}`;
  },

  getAgenciesCannotBeAssignedErrorMessage: (performingAgencyName: string) => {
    return `One or more of the agencies provided cannot be assigned by ${performingAgencyName}`;
  },

  getAgencyCannotBeDeletedErrorMessage: (
    name: string,
    connectedEmployers: string[]
  ) => {
    return `Agency ${name} could not be deleted because it is the enrollment team for ${connectedEmployers.join(
      ', '
    )}`;
  },

  getAgencyContactHasNoEmailErrorMessage: (id: string) => {
    return `No email found for agency contact: ${id}`;
  },

  getAgencyNotFoundErrorMessage: (id: string) => {
    return `Agency ${id} not found`;
  },
  getAgencyTypeCannotBeChangedErrorMessage: (name: string) => {
    return `Agency type could not be changed for ${name} because it has connected employers`;
  },

  getAgentCannotBeDeletedHasConnectedBenefitsErrorMessage: (
    firstName: string,
    lastName: string,
    connectedBenefitsAmount: number
  ) => {
    return `Agent ${firstName} ${lastName} could not be deleted because it is the enrollment agent for ${connectedBenefitsAmount} benefits`;
  },

  getAgentCannotBeDeletedHasConnectedProducerEmployersErrorMessage: (
    firstName: string,
    lastName: string,
    connectedEmployers: string[]
  ) => {
    const [firstEmployer, ...otherEmployers] = connectedEmployers;
    const others =
      otherEmployers.length === 0
        ? ''
        : ` and ${otherEmployers.length} other ${
            otherEmployers.length === 1 ? 'employer' : 'employers'
          }`;
    return `Agent ${firstName} ${lastName} could not be deleted because it is the producer agent for ${firstEmployer}${others}`;
  },

  getAgentCannotEditErrorMessage: (propertyName: string) => {
    return `An agent cannot edit an agency's ${propertyName}`;
  },

  getAgentNotFoundError: (id: string) => {
    return `Agent ${id} not found`;
  },

  getAllowanceModelNotConfiguredErrorMessage: () => {
    return 'Employees cannot be added until an allowance model is set';
  },

  getAllowanceModelRequiredForPlanYearErrorMessage: () => {
    return 'An allowance model is required because the employer has employees';
  },

  getBenefitNotFoundErrorMessage: (benefitId: string) => {
    return `Benefit ${benefitId} not found`;
  },

  getCannotDeleteInsuredOfOrphanedBenefit: (name: string) => {
    return `${name} cannot be removed because they are the only insured on a benefit. Remove the benefit first.`;
  },

  getCannotResarttEligibilityErrorMessage: (employeeName: string) => {
    return `Cannot restart eligibility for ${employeeName} because current eligibility data is incomplete.`;
  },

  getCensusPlanIdNotFoundErrorMessage: (
    planId: string,
    planYears: number[]
  ) => {
    return `Plan ID ${planId} could not be found in any of these plan years: ${planYears.join(', ')}. Please verify it in the census.`;
  },

  getCensusPlansDoNotMatchErrorMessage: (planNames: string[]) => {
    return `${planNames.join(
      ', '
    )} are not listed in any of the census employees`;
  },

  getCouldNotCreateOneOrMoreUsersErrorMessage: () => {
    return 'Could not create one or more users';
  },

  getCouldNotDeleteEmployerErrorMessage: (employerName: string) => {
    return `Employer ${employerName} could not be deleted. Please contact support for assistance`;
  },

  getDependantOverageError: (name: string) => {
    return `${name} must be under 26 years old on the coverage effective date`;
  },

  getEmailInUseInByAnotherTenantError: (email: string) => {
    return `The email address ${email} is already in use by a user in another tenant`;
  },

  getEmployeeAlreadyExistsErrorMessage: (email: string) => {
    return `Employee with email: ${email} already exists`;
  },

  getEmployeeCountNotFoundErrorMessage: (employerId: string) => {
    return `Could not find the total employee count for employer with id ${employerId}`;
  },

  getEmployeeHasEnrollmentDataErrorMessage: (employeeId: string) => {
    return `Employee ${employeeId} cannot be deleted because they have existing enrollments. Please contact support for assistance`;
  },

  getEmployeeNotFoundErrorMessage: (id: string) => {
    return `Employee with id ${id} not found`;
  },

  getEmployeePricingCountyNotFoundErrorMessage: (employeeId: string) => {
    return `Pricing county not found for employee: ${employeeId}`;
  },

  getEmployerContactHasNoEmailErrorMessage: (id: string) => {
    return `No email found for employer contact: ${id}`;
  },

  getEmployerHasEmployeesErrorMessage: (employerId: string) => {
    return `Employer ${employerId} should have no employees prior to deletion`;
  },

  getEmployerNotFoundErrorMessage: (employerId: string) => {
    return `Employer with id ${employerId} not found`;
  },

  getEnrollmentCommentNotFoundErrorMessage: (id: string) => {
    return `Enrollment comment ${id} not found`;
  },

  getEntityNotFoundErrorMessage: (id: string) => {
    return `Entity ${id} not found`;
  },

  getFailedToApplyAllowanceModelErrorMessage: (message: string = '') =>
    `Failed to apply allowance model: ${message}`,

  getIncorrectFormatMessage: (tableName: string) =>
    `Incorrect file format for "${tableName}" table`,

  getInsufficientCensusDataErrorMessage: (quoteId: string) => {
    return `The census data is insufficient to create a quote for: ${quoteId}`;
  },

  getInsuredNotFoundErrorMessage: (periodId: string) => {
    return `Insured people not found for onboarding period ${periodId}`;
  },

  getInsuredUnderageError: (name: string) => {
    return `${name} must be at least 18 years old on the coverage effective date`;
  },

  getInvalidAddressErrorMessage: (address: string, reason?: string) => {
    return `Could not validate '${address}': ${reason ?? 'unexpected error'}`;
  },

  getInvalidBenefitsErrorMessage: (onboardingPeriodId: string) => {
    return `More than one benefit of the same type was found for onboarding period: ${onboardingPeriodId}`;
  },

  getInvalidChildCountErrorMessage: (employeeId: string) => {
    return `Invalid child count for employee ${employeeId}`;
  },

  getInvalidDataAtRowWithDetailsErrorMessage: (
    index: number,
    plan: {
      id: string;
      carrier: string;
      type: string;
    }
  ) => {
    return `[plan-diversity] Invalid data at row ${index}: ${JSON.stringify(
      plan
    )}`;
  },

  getInvalidDataAtRowWithPlanDataErrorMessage: (index: number) => {
    return `[plan-data] Invalid data at row ${index}`;
  },

  getInvalidFamilyUnitErrorMessage: (familyUnit: string) => {
    return `[scenarios] Invalid family unit: ${familyUnit}`;
  },

  getInvalidMedicalPlanFilterErrorMessage: (
    filterExpression: string,
    message: string
  ) => {
    return `Medical plan filter "${filterExpression}" is invalid: ${message}`;
  },

  getInvalidPersonalDetailErrorMessage: (
    personalDetailKey: string,
    personalDetailValue: string,
    extra?: string
  ) => {
    return [
      `Invalid ${personalDetailKey} : '${personalDetailValue}'`,
      extra,
    ].join('. ');
  },

  getMajorMedicalPlanNotSelfReportedErrorMessage: (benefitId: string) => {
    return `Major medical plan ${benefitId} is not self-reported`;
  },

  getMissingScenarioInPlanDesignErrorMessage: (planDesignId: string) => {
    return `Plan design ${planDesignId} is missing a scenario. Please choose a scenario to the plan design`;
  },

  getMixedCensusPlanIdentifiersErrorMessage: () => {
    return 'A census must identify current plans one way: by plan name or by plan ID, not a mix of both. Employees with no current plan can be left blank';
  },

  getNoAllowanceFoundErrorMessage: (employeeId: string) => {
    return `No allowance found for employee: ${employeeId}`;
  },

  getNoInsuredFoundErrorMessage: (onboardingPeriodId: string) => {
    return `No insured found for onboarding period ${onboardingPeriodId}`;
  },

  getNoOpenEnrollmentPeriodsFoundErrorMessage: (employerId: string) => {
    return `Open Enrollment Period for employer ${employerId} not found`;
  },

  getNotValidPlanYearErrorMessage: () => {
    return 'No plans available for the requested plan year';
  },

  getNoZipCodeFoundErrorMessage: (employeeId: string) => {
    return `No zip code found for employee ${employeeId}`;
  },

  getOnboardingPeriodNotFoundErrorMessage: (id: string) => {
    return `Onboarding Period ${id} not found`;
  },

  getOnboardingPeriodReportNotFoundErrorMessage: (id: string) => {
    return `Onboarding Period Report ${id} not found`;
  },

  getOpenEnrollmentPeriodNotFoundErrorMessage: (
    openEnrollmentPeriodId: string
  ) => {
    return `Open Enrollment Period ${openEnrollmentPeriodId} not found`;
  },

  getPlanPricingZipNotFoundErrorMessage: (
    zipCode: string,
    planId: string,
    planYear: number
  ) => {
    return `Plan pricing not found for zip code: ${zipCode}, plan id: ${planId} and plan year: ${planYear}`;
  },

  getPlanSearchDataMissingErrorMessage: (missingField: string) => {
    return `${missingField} is required for plan search`;
  },

  getProfilingInvalidStepTransitionErrorMessage: (
    currentStep: string,
    completedSteps: string[]
  ) => {
    return `Invalid step transition: ${currentStep} cannot follow completed steps [${completedSteps.join(', ')}]`;
  },

  getProfilingOverlappingStepsErrorMessage: (overlapping: string[]) => {
    return `Steps cannot appear in both completed and skipped: [${overlapping.join(', ')}]`;
  },

  getProfilingPreferencesNotFoundErrorMessage: (onboardingPeriodId: string) => {
    return `Profiling preferences not found for onboarding period ${onboardingPeriodId}`;
  },

  getProfilingProgressNotFoundErrorMessage: (onboardingPeriodId: string) => {
    return `Profiling progress not found for onboarding period ${onboardingPeriodId}`;
  },

  getProfilingUnauthorizedErrorMessage: (
    employeeId: string,
    onboardingPeriodId: string
  ) => {
    return `Employee ${employeeId} does not own onboarding period ${onboardingPeriodId}`;
  },

  getQuoteNotFoundErrorMessage: (quoteId: string) => {
    return `Quote not found: ${quoteId}`;
  },

  getQuotePlanDesignNotFoundErrorMessage: (planId: string) => {
    return `Quote plan design not found: ${planId}`;
  },

  getQuotePreferenceNotFoundErrorMessage: (quoteId: string) => {
    return `Quote preferences not found: ${quoteId}`;
  },

  getRatingAreaNotFoundErrorMessage: (fipsCode: string, zipCode: string) => {
    return `Rating area not found for fips code: ${fipsCode} and zip code: ${zipCode}`;
  },

  getRoleNotFoundErrorMessage: (
    newRole: string,
    roleToIdMap: Record<string, string>
  ) => {
    return `Role with key ${newRole} not found in Frontegg roles: ${JSON.stringify(
      Object.keys(roleToIdMap)
    )}`;
  },

  getScenariosInvalidDataAtRowErrorMessage: (index: number) => {
    return `[scenarios] Invalid data at row ${index}`;
  },

  getSubEntitiesNotEmptyError: (
    subEntities: string[],
    type: 'sub-entity' | 'sub-entity 2' = 'sub-entity'
  ) => {
    return `One of the following ${type}s are not empty: ${subEntities.join(
      ', '
    )}. Please remove all employees in the ${type} before deleting the ${type}.`;
  },

  getSubEntityNotFoundError: (
    name: string,
    employerId: string,
    type: 'sub-entity' | 'sub-entity 2' = 'sub-entity'
  ) => {
    return `${type} with name ${name} under employer ${employerId} was not found`;
  },

  getUnexpectedQuoteProcessingErrorMessage: () => {
    return 'Could not generate a valid quote. Please retry later or contact support if the issue persists';
  },

  getUnrecognizedContactTypeErrorMessage: (contactType: string) => {
    return `Contact type ${contactType} not recognized`;
  },

  getUserExistsError: (email: string) => {
    return `A user with email ${email} already exists`;
  },

  getUserNotFoundError: (emailOrId: string) => {
    return `User ${emailOrId} not found`;
  },

  getUserSetupIncompleteErrorMessage: (email: string) => {
    return `User with email ${email} has not completed the setup and has no name yet`;
  },

  getUsersExistInDifferentTenantsErrorMessage: (
    conflicts: { email: string; tenantId: string }[],
    attemptedTenantId: string
  ) => {
    const conflictList = conflicts
      .map((conflict) => `${conflict.email} (tenant: ${conflict.tenantId})`)
      .join(', ');
    return `The following users already exist in different tenants: ${conflictList}. Cannot create them in tenant ${attemptedTenantId}.`;
  },

  getUsersNotFoundError: (missingCount: number, selectedCount: number) => {
    if (selectedCount === 1) {
      return 'Could not find the selected employee';
    }
    return `Could not find ${missingCount} of the ${selectedCount} selected employees`;
  },

  HIRE_DATE_REQUIRED_MSG:
    'Hire date is a required field. Please include it in your input',

  INSURED_EMPLOYEE_ALREADY_EXISTS: 'An employee already exists',

  INSURED_UNDERAGE_ERROR:
    'Insured must be at least 18 years old on the coverage effective date',

  INVALID_MONTHLY_SEP_DEADLINE_ERROR_MESSAGE: 'Invalid monthly SEP deadline',

  LIFE_EVENT_DATE_RANGE_ERROR_MESSAGE:
    'Qualifying Life Event date is out of date range',

  LIFE_EVENT_NOT_FOUND_ERROR_MESSAGE: 'Qualifying Life Event not found',

  LIFE_EVENT_NOT_FOUND_FOR_ONBOARDING_PERIOD_ERROR_MESSAGE:
    'Qualifying Life Event for onboarding period not found',

  LIFE_EVENT_OTHER_REASON_ERROR_MESSAGE:
    'Qualifying Life Event other type must have other reason',

  MEDICAL_BENEFIT_SUBMISSION_ERROR_MESSAGE:
    'could not submit a plan for the major medical benefit',

  MEDICAL_PLAN_NOT_FOUND_ERROR_MESSAGE: 'Medical plan not found',

  NAICS_CODE_REQUIRED_MSG:
    'Naics code is a required field. Please include it in your input',

  NO_DATA_FOUND_IN_THE_FILE_ERROR_MESSAGE: 'No data found in the file',

  NO_FILE_SELECTED_ERROR_MESSAGE: 'No file selected',

  NO_REQUEST_CONTEXT_ERROR_MESSAGE:
    'No http request context found, are you running a cron job? use m2mClient instead',

  ONBOARDING_PERIOD_NOT_FOUND_FOR_LIFE_EVENT_ERROR_MESSAGE:
    'Onboarding period for Qualifying Life Event not found',

  OnboardingPeriodWithElectionWindowStartDateAlreadyExistsErrorMessage:
    'An onboarding period with the same election window start date already exists for employee',

  ONE_OF_REQUIRED_FIELDS_MISSED_ERROR_MESSAGE:
    'One of the required fields is missing. Please check your input and try again',

  OPEN_ENROLLMENT_INVALID_START_DATE_ERROR:
    'Coverage must begin on the first day of the plan year for open enrollment',

  OVERLAPPING_PERIOD_ERROR_MESSAGE: 'Open enrollment periods cannot overlap',

  PLAN_DESIGN_WITH_WORK_STATUS_MAST_HAVE_TWO_CONTRIBUTION_ENTITIES_ERROR:
    'Plan design with work status must have two contribution entities',

  QUOTE_ENCOUNTERED_ERRORS_ERROR_MESSAGE:
    'Could not generate a valid quote. See details below.',

  RENEWAL_ONBOARDING_PERIOD_NOT_ACTIVE_ERROR_MESSAGE:
    'Renewal requires an active onboarding period.',

  RENEWAL_PLAN_NOT_AVAILABLE_ERROR_MESSAGE:
    'This onboarding period has no renewal plan available this year.',

  SELF_PAY_AMOUNT_TOO_LARGE_ERROR_MESSAGE:
    'Self pay amount cannot be larger than the premium amount',

  START_OF_COVERAGE_NOT_WITHIN_COVERAGE_PERIOD_ERROR:
    'The expected start of coverage must fall within the plan year’s coverage period',

  SUBMISSION_DEADLINE_MISSED_ERROR_MESSAGE:
    'Submission Deadline Missed: It’s now too late to submit this life event. For assistance, please contact support',

  THERE_ARE_ALREADY_EXISTING_ENROLLMENTS_FOR_THIS_YEAR:
    'There are already existing enrollments for this year.',

  TOKEN_CLIENT_NOT_INITIALIZED_ERROR_MESSAGE: 'Token client not initialized',

  UNEXPECTED_ERROR_FOR_QLE_ERROR_MESSAGE:
    'Could not generate a special enrollment for QLE. Please retry later or contact support if the issue persists',

  UPLOADING_EMPLOYER_LOGO_FAILED_ERROR_MESSAGE:
    'Uploading employer logo failed',
};
